import { all, put, select, takeLatest } from 'redux-saga/effects';
import { MessagesActionTypes } from './messages-actions';
import { AlertActionType } from '@store/alert/alert-action';
import { messagesStore } from './messages-store';
import messagesListApi from '@api/clients/messages/messages-list';
import markAsReadApi from '@api/clients/messages/mark-as-read';
import { AuthActionTypes } from '@store/auth/auth-actions';
import { homeStore } from '@store/home-screen/home-store';
import getDictionary from '@dictionaries-client';

function* getMessagesListWatcher() {
  const { locale } = yield select(homeStore);
  const { api: { client: { message: { messages } } } } = getDictionary(locale);
  try {
    const { currentPage, limit } = yield select(messagesStore);
    const response: { data: Array<object> } = yield messagesListApi({ page: currentPage, limit: limit });
    yield put({
      type: MessagesActionTypes.SET_MESSAGES_LIST,
      data: response?.data,
    });
  } catch (error: any) {
    yield put({
      type: AlertActionType.SHOW_ALERT,
      text: error?.message || messages.get_info_error,
      severity: 'danger',
    });
  }
}

function* setMessagesAsReadWatcher() {
  const { locale } = yield select(homeStore);
  const { api: { client: { message: { messages } } } } = getDictionary(locale);
  try {
    const { markAsReadList } = yield select(messagesStore);
    yield markAsReadApi({ ids: markAsReadList });
    yield put({ type: MessagesActionTypes.GET_MESSAGES_LIST });
    yield put({ type: AuthActionTypes.GET_CLIENT_INFO });
  } catch (error: any) {
    yield put({
      type: AlertActionType.SHOW_ALERT,
      text: error?.message || messages.read_messages_error,
      severity: 'danger',
    });
    yield put({ type: MessagesActionTypes.SET_MESSAGES_LIST });
  }
}

function* messagesMiddleware() {
  yield all([
    takeLatest(MessagesActionTypes.GET_MESSAGES_LIST, getMessagesListWatcher),
    takeLatest(MessagesActionTypes.GET_EXTENDED_MESSAGE_LIST, getMessagesListWatcher),
    takeLatest(MessagesActionTypes.SET_MESSAGES_AS_READ, setMessagesAsReadWatcher),
  ]);
}

export default messagesMiddleware;
